import { render, staticRenderFns } from "./SundryCostListSettings.vue?vue&type=template&id=7af4152c&scoped=true&"
import script from "./SundryCostListSettings.vue?vue&type=script&lang=js&"
export * from "./SundryCostListSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4152c",
  null
  
)

export default component.exports